onImgLoad.$inject = ['CoreDirectivesService'];

export default function onImgLoad(CoreDirectivesService) {
    return CoreDirectivesService.getEventCallbackDirectiveConfig('load', 'onImgLoad');
}
